import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as selectors from './selectors';
import * as actions from './actions';
import * as generalActions from './../general/actions';
import * as generalSelectors from './../general/selectors';
import { getFilters, clearAndGetFilters, setInitialFilters } from './../filters/operations';
import { getTestCases } from './../test-list/operations';
import { getAggregatedTestErrors } from './../test-error/operations';

export const getTrends = () => (dispatch, getState) => {
  const params = selectors.testOverviewFilterParamsSelector(getState());
  return dispatch(actions.getTrends(params));
};

export const getPastTrends = () => (dispatch, getState) => {
  const params = selectors.testOverviewFilterParamsSelector(getState(), { priorData: true });
  return dispatch(actions.getPastTrends(params));
};

export const getTestHealth = () => (dispatch, getState) => {
  const params = selectors.testOverviewFilterParamsSelector(getState());
  return dispatch(actions.getTestHealth(params));
};

export const getPastHealth = () => (dispatch, getState) => {
  const params = selectors.testOverviewFilterParamsSelector(getState(), { priorData: true });
  return dispatch(actions.getPastHealth(params));
};

export const loadSummary = () => (dispatch) => Promise.all([
  dispatch(getFilters()),
  dispatch(getTrends()),
  dispatch(getPastTrends()),
  dispatch(getTestHealth()),
  dispatch(getPastHealth()),
]).catch((error) => {
  dispatch(notificationActions.notifyDanger(
    error.message, 'We\'ve experienced an issue loading test summary data.', true,
  ));
});

export const loadTestsList = (payload) => (dispatch) => Promise.all([
  dispatch(getFilters()),
  dispatch(getTestCases(payload)),
]).catch((error) => {
  dispatch(notificationActions.notifyDanger(
    error.message, 'We\'ve experienced an issue loading test data.', true,
  ));
});

export const loadErrors = () => (dispatch) => Promise.all([
  dispatch(getFilters()),
  dispatch(getTrends()),
  dispatch(getPastTrends()),
  dispatch(getAggregatedTestErrors()),
]).catch((error) => {
  dispatch(notificationActions.notifyDanger(
    error.message, 'We\'ve experienced an issue loading test error data.', true,
  ));
});

export const clearFilters = (location) => (dispatch) => Promise.all([
  dispatch(clearAndGetFilters(null, { location })),
]);

export const TAB_LOAD_OPERATIONS = Object.freeze({
  overview: loadSummary,
  tests: loadTestsList,
  errors: loadErrors,
});

export const updateTabData = (tabName) => (dispatch) => {
  dispatch(TAB_LOAD_OPERATIONS[tabName]());
};

export const loadInitData = () => (dispatch, getState) => (
  dispatch(generalActions.loadInitData(
    Promise.all([
      dispatch(clearAndGetFilters()),
      dispatch(setInitialFilters(...generalSelectors.initialFilterSelector(getState()))),
    ]).catch((error) => {
      dispatch(notificationActions.notifyDanger(
        error.message, 'We\'ve experienced an issue while loading data.', true,
      ));
    }),
  ))
);
